<!-- 日期选择 -->
<template>
  <el-form-item :label="label">
    <el-date-picker
      v-model="date"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="YYYY-MM-DD"
      :disabledDate="disabledDate"
      :shortcuts="config.isShowFuture?futureShortcuts:shortcuts"
      @change="$emit('change', $event)"
    >
    </el-date-picker>
  </el-form-item>
</template>

<script>
import { computed, inject } from 'vue';

export default {
  kind: 'yq-日期选择',
  props: {
    // 初始值.
    value: {
      type: [Object],
      default() {
        return {
          startDate: '',
          endDate: '',
        };
      },
    },
    disabledDate: Function,
    label: {
      type: String,
      default: '操作日期：',
    },
    config: {
      type: Object,
      default() {
        return {
          isShowFuture: false,
        };
      },
    },
    validator: Function,
  },
  setup(props) {
    const { date: dateTool } = inject('app');
    const useQuery = inject('useQuery');
    const dateModel = useQuery('dateRange', props.value);
    const date = computed({
      get() {
        return [dateModel.value.startDate, dateModel.value.endDate];
      },
      set(val) {
        if (val === null) {
          dateModel.value.startDate = '';
          dateModel.value.endDate = '';
          return;
        }
        if (!(props.validator && !props.validator(val))) {
          dateModel.value.startDate = val?.[0] || '';
          dateModel.value.endDate = val?.[1] || '';
        }
      },
    });

    return {
      date,
      shortcuts: [
        {
          text: '今天',
          value: [dateTool.getDayDiff(0), dateTool.getDayDiff(0)],
        },
        {
          text: '昨天',
          value: [dateTool.getDayDiff(-1), dateTool.getDayDiff(-1)],
        },
        {
          text: '本周',
          value: dateTool.getWeekDiff(0),
        },
        {
          text: '上周',
          value: dateTool.getWeekDiff(-1),
        },
        {
          text: '近7天',
          value: [dateTool.getDayDiff(-6), dateTool.getDayDiff(0)],
        },
        {
          text: '本月',
          value: dateTool.getMonthDiff(0),
        },
        {
          text: '上月',
          value: dateTool.getMonthDiff(-1),
        },
        {
          text: '近30天',
          value: [dateTool.getDayDiff(-29), dateTool.getDayDiff(0)],
        },
        {
          text: '近60天',
          value: [dateTool.getDayDiff(-59), dateTool.getDayDiff(0)],
        },
        {
          text: '本季度',
          value: dateTool.getQuarterDiff(0),
        },
        {
          text: '上季度',
          value: dateTool.getQuarterDiff(-1),
        },
        {
          text: '近3个月',
          value: dateTool.getMonthRangeDiff(-3),
        },
        {
          text: '近6个月',
          value: dateTool.getMonthRangeDiff(-6),
        },
      ],
      futureShortcuts: [
        {
          text: '今天',
          value: [dateTool.getDayDiff(0), dateTool.getDayDiff(0)],
        }, {
          text: '明天',
          value: [dateTool.getDayDiff(1), dateTool.getDayDiff(1)],
        }, {
          text: '本周',
          value: dateTool.getWeekDiff(0),
        },
        {
          text: '下周',
          value: dateTool.getWeekDiff(1),
        },
        {
          text: '未来7天',
          value: [dateTool.getDayDiff(0), dateTool.getDayDiff(6)],
        },
        {
          text: '本月',
          value: dateTool.getMonthDiff(0),
        },
        {
          text: '下月',
          value: dateTool.getMonthDiff(1),
        },
        {
          text: '未来30天',
          value: [dateTool.getDayDiff(0), dateTool.getDayDiff(29)],
        },
        {
          text: '本季度',
          value: dateTool.getQuarterDiff(0),
        },
        {
          text: '下季度',
          value: dateTool.getQuarterDiff(1),
        },
        {
          text: '未来3个月',
          value: [dateTool.getMonthDiff(1)[0], dateTool.getMonthDiff(3)[1]],
        },
        {
          text: '未来6个月',
          value: [dateTool.getMonthDiff(1)[0], dateTool.getMonthDiff(6)[1]],
        },
      ],
    };
  },
};
</script>
